import { WebSocketMessageType } from 'constants/notificationConstants'

// Importing message handlers for different WebSocket message types
import { handleUploadOrgDataMessage } from './messageHandlers/uploadOrgData'
import { handleWebSocketMessageGeneral } from './messageHandlers/general'
import { handleUploadMarketDataMessage } from './messageHandlers/uploadMarketData'

function handleDefaultHandler(data) {
  console.log('Unhandled WebSocket message type:', data)
}

export const messageHandlers = {
  [WebSocketMessageType.GENERAL]: handleWebSocketMessageGeneral,
  [WebSocketMessageType.UPLOAD_ORG_DATA]: handleUploadOrgDataMessage,
  [WebSocketMessageType.UPLOAD_MARKET_DATA]: handleUploadMarketDataMessage,
  defaultHandler: handleDefaultHandler,
}
